export default {
  install(app, handlers = {}) {
    app.mixin({
      beforeCreate() {
        const notifications = this.$options.notifications;

        if (!notifications || typeof notifications !== "object") {
          return;
        }

        Object.keys(notifications).forEach(methodName => {
          if (typeof this[methodName] === "function") {
            return;
          }

          this[methodName] = (payload = {}) => {
            const config = this.$options.notifications?.[methodName] || {};
            const normalizedPayload =
              payload && typeof payload === "object" ? payload : { message: payload };
            const type = normalizedPayload.type || config.type || "info";
            const handler = handlers[type];

            if (typeof handler !== "function") {
              return undefined;
            }

            return handler({
              title:
                normalizedPayload.title !== undefined
                  ? normalizedPayload.title
                  : config.title,
              message: normalizedPayload.message,
              type,
              timeout: normalizedPayload.timeout,
              cb: normalizedPayload.cb
            });
          };
        });
      }
    });
  }
};
